module.exports = __webpack_public_path__ + "static/img/WATCH_GT2_Woman.48ee3a1f.jpg";